export const setBase = (orgSlug: string, uuid: string, heroVideoId: string, pageId: string) => {
  return {
    organisation: orgSlug === 'nationalworld' ? 'derbyshiretimes' : orgSlug,
    video_id: heroVideoId,
    page_id: pageId,
    uuid,
    referrer: window.top.document.referrer || null,
    url: window.top.location.href,
    device: /Mobi/i.test(window.navigator.userAgent) ? 'mobile' : 'desktop'
  };
};